
import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, Form, Spinner, Alert, Row, Col, Badge } from 'react-bootstrap';
import { FaSave, FaTimes, FaCalculator, FaLock, FaInfo, FaMoneyBillWave, FaExclamationTriangle } from 'react-icons/fa';
import api from '../services/api';


const PaymentPlanModal = ({ show, onHide, report, onUpdate }) => {
 
    const [showFinancialDetails, setShowFinancialDetails] = useState(false);
    const [showPaymentList, setShowPaymentList] = useState(false);
    const [showEarlyCalculator, setShowEarlyCalculator] = useState(false); 
    const [settlementData, setSettlementData] = useState(null);
    const [existingSettlement, setExistingSettlement] = useState(null);
    const [loadingCalculate, setLoadingCalculate] = useState(false);
    const [loadingConfirm, setLoadingConfirm] = useState(false);
    const [error, setError] = useState('');   
    const [paymentPlan, setPaymentPlan] = useState([]);
    const [saving, setSaving] = useState(false);

 
    useEffect(() => {
        if (show && report) {
            fetchFreshReport(); // Fresh data çek
            checkExistingSettlement();

            setShowPaymentList(true);
            setShowFinancialDetails(false);
        }
    }, [show, report]);

    // db ye kaydedilen erken kapama verisini cekecek
    const fetchFreshReport = async () => {
        try {
            const response = await api.get(`/reports/${report._id}`);
            if (response.data.success) {
                // Fresh report data'sından direkt payment plan al
                const freshReport = response.data.report;
                if (freshReport.paymentPlan && freshReport.paymentPlan.length > 0) {
                    const planWithStatus = freshReport.paymentPlan.map(payment => ({
                        ...payment,
                        paymentStatus: payment.paymentStatus || 'pending'
                    }));
                    setPaymentPlan(planWithStatus);
                    console.log('✅ Fresh payment plan loaded:', planWithStatus);
                    // *** YENİ: DUPLICATE KONTROLÜ ***
                    const taksitNos = planWithStatus.map(p => p.taksit);
                    const duplicateTaksitler = taksitNos.filter((item, index) => taksitNos.indexOf(item) !== index);
                    if (duplicateTaksitler.length > 0) {
                        console.error('⚠️⚠️⚠️ DUPLICATE TAKSIT FOUND IN FRONTEND:', duplicateTaksitler);
                        console.table(planWithStatus.filter(p => duplicateTaksitler.includes(p.taksit)));
                    }
                } else {
                    initializePaymentPlan();
                }
            } else {
                initializePaymentPlan();
            }
        } catch (error) {
            console.error('Fresh report çekilemedi:', error);
            initializePaymentPlan();
        }
    };

   
    const initializePaymentPlan = () => {
        if (!report) return;

        const { financialData } = report;
        const { term, monthlyPayment } = financialData;

        if (report.paymentPlan && report.paymentPlan.length === term) {
            console.log('Using existing payment plan');
            const planWithStatus = report.paymentPlan.map(payment => ({
                ...payment,
                paymentStatus: payment.paymentStatus || 'pending'
            }));
            setPaymentPlan(planWithStatus);
        } else {
            console.log('Creating new payment plan for term:', term);
            const plan = [];
            const startDate = new Date(report.createdAt);

            for (let i = 1; i <= term; i++) {
                const dueDate = new Date(startDate);
                dueDate.setMonth(dueDate.getMonth() + i);

                if (dueDate.getDay() === 0) {
                    dueDate.setDate(dueDate.getDate() + 1);
                } else if (dueDate.getDay() === 6) {
                    dueDate.setDate(dueDate.getDate() + 2);
                }

                plan.push({
                    taksit: i,
                    taksitTarihi: dueDate.toISOString().split('T')[0],
                    taksitTutari: monthlyPayment,
                    anapara: 0,
                    kar: 0,
                    kalanAnapara: 0,
                    paymentStatus: 'pending'
                });
            }
            setPaymentPlan(plan);
        }
    };

   
    const checkExistingSettlement = async () => {
        try {
            const response = await api.get(`/early-settlements/report/${report._id}`);
            if (response.data.success) {
                setExistingSettlement(response.data.settlement);
                console.log('✅ Existing settlement found:', response.data.settlement);
            }
        } catch (error) {
            // 404 = settlement yok, normal durum
            if (error.response?.status === 404) {
                setExistingSettlement(null);
                console.log('ℹ️ No existing settlement');
            } else {
                console.error('❌ Settlement check error:', error);
            }
        }
    };

   
    const handleCalculateEarlySettlement = async () => {

        try {
            setLoadingCalculate(true);
            setError('');

            console.log('🧮 Calculating early settlement for report:', report._id);

            const response = await api.get(`/early-settlements/calculate/${report._id}`);



            if (response.data.success) {

                setSettlementData(response.data.calculation);
                setShowEarlyCalculator(true);
                console.log('✅ Settlement calculation successful:', response.data.calculation);
            }
        } catch (error) {
            console.error('❌ Settlement calculation error:', error);

            setError(error.response?.data?.message || 'Hesaplama sırasında hata oluştu');
        } finally {
            setLoadingCalculate(false);
        }
    };
  
    const handleConfirmEarlySettlement = async () => {
        try {
            setLoadingConfirm(true);
            setError('');

            console.log('🔐 Confirming early settlement...');

            const response = await api.post(`/early-settlements/confirm/${report._id}`, {
                ...settlementData,
                paidInstallmentCount: settlementData.paidInstallmentCount
            });

            if (response.data.success) {
                console.log('✅ Settlement confirmed and saved to DB');

                // Settlement tamamlandı, UI'ı güncelle
                setExistingSettlement(response.data.settlement);
                setShowEarlyCalculator(false);
                setShowFinancialDetails(false);

                // Parent component'e haber ver
                onUpdate && onUpdate(report);

                // Success feedback
                alert('Erken settlement başarıyla tamamlandı!');
            }
        } catch (error) {
            console.error('❌ Settlement confirmation error:', error);
            setError(error.response?.data?.message || 'Onaylama sırasında hata oluştu');
        } finally {
            setLoadingConfirm(false);
        }
    };

    /*
    LEGACY FUNCTIONS - V1.0'DAN KALAN (Değiştirilmedi)
    */
    const handleStatusChange = (index, newStatus) => {
        const updatedPlan = [...paymentPlan];
        updatedPlan[index] = {
            ...updatedPlan[index],
            paymentStatus: newStatus
        };
        setPaymentPlan(updatedPlan);
    };

    const handleSave = async () => {
        try {
            setSaving(true);
            setError('');

            const response = await api.put(`/reports/${report._id}/payment-plan`, {
                paymentPlan
            });

            if (response.data.success) {
                onUpdate && onUpdate(response.data.report);
                setShowPaymentList(false);
            }
        } catch (error) {
            console.error('Ödeme planı kaydetme hatası:', error);
            setError('Ödeme planı kaydedilirken hata oluştu');
        } finally {
            setSaving(false);
        }
    };

    /*
    UTILITY FUNCTIONS
    */
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: 0
        }).format(amount);
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('tr-TR');
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'paid':
                return 'success';
            case 'erken_kapama':
                return 'info';
            case 'restructured':
                return 'secondary'; // Yapılandırıldı - gri
            case 'pending':
            default:
                return 'warning';
        }
    };

    const getPaidCount = () => {
        return paymentPlan.filter(p => p.paymentStatus === 'paid' && !p.isRestructured).length;
    };

    /*
    MAIN MODAL ROUTER - HANGI MODAL AÇIK?
    */
    if (!report) return null;

 if (showFinancialDetails) {

    return (
        <Modal show={true} onHide={() => {
            setShowFinancialDetails(false);
            onHide();
        }} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    <FaInfo className="text-primary me-2" />
                    Finansman Detayları - {report.customerData?.name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && (
                    <Alert variant="danger" className="mb-3">
                        {error}
                    </Alert>
                )}

                {/* ORİJİNAL FİNANSMAN BİLGİLERİ */}
                <div className="mb-4">
                    <h5 className="text-primary">📊 ORİJİNAL FINANSMAN</h5>
                    <Row>
                        <Col md={6}>
                            <p><strong>Kredi Tutarı:</strong> {formatCurrency(report.financialData?.loanAmount || 0)}</p>
                            <p><strong>Aylık Taksit:</strong> {formatCurrency(report.financialData?.monthlyPayment || 0)}</p>
                        </Col>
                        <Col md={6}>
                            <p><strong>Vade:</strong> {report.financialData?.term} ay</p>
                            <p><strong>Faiz Oranı:</strong> %{report.financialData?.interestRate}</p>
                        </Col>
                    </Row>
                </div>

                {/* ERKEN SETTLEMENT BİLGİSİ (VARSA) */}
                {existingSettlement && (
                    <div className="mb-4">
                        <h5 className="text-success">💰 ERKEN SETTLEMENT (TAMAMLANDI)</h5>
                        <div className="alert alert-success">
                            <p><strong>Tarih:</strong> {formatDate(existingSettlement.confirmationDate)}</p>
                            <p><strong>Toplam Ödenen:</strong> {formatCurrency(existingSettlement.totalEarlyPayment)}</p>
                            <p><strong>Onaylayan:</strong> {existingSettlement.confirmedBy?.name || 'Admin'}</p>
                        </div>
                    </div>
                )}

                {/* BUTON KISMI */}
                <div className="text-center py-3 border-top">
                    <Button
                        variant="success"
                        size="lg"
                        onClick={handleCalculateEarlySettlement}
                        disabled={loadingCalculate || existingSettlement}
                    >
                        {loadingCalculate ? (
                            <>
                                <Spinner size="sm" animation="border" className="me-2" />
                                Hesaplanıyor...
                            </>
                        ) : (
                            <>
                                💰 Erken Kapama Hesapla
                            </>
                        )}
                    </Button>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    setShowFinancialDetails(false);
                    onHide();
                }}>
                    <FaTimes className="me-2" />
                    Kapat
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

    if (showPaymentList) {
        const isSettled = existingSettlement !== null;
        return (
            <Modal show={true} onHide={() => {
                setShowPaymentList(false);
                onHide();
            }} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Ödeme Planı - {report.customerData?.name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* SETTLEMENT UYARISI */}
                    {isSettled && (
                        <Alert variant="warning" className="mb-3">
                            <FaExclamationTriangle className="me-2" />
                            ⚠️ Bu senet erken kapatılmıştır. Aşağıdaki taksitler orijinal veridir ve değiştirilemez.
                        </Alert>
                    )}

                    {error && (
                        <Alert variant="danger" className="mb-3">
                            {error}
                        </Alert>
                    )}

                    <div className="mb-3">
                        <div className="row">
                            <div className="col-md-3">
                                <strong>Toplam Taksit:</strong> {report.financialData?.term} ay
                            </div>
                            <div className="col-md-3">
                                <strong>Aylık Tutar:</strong> {formatCurrency(report.financialData?.monthlyPayment || 0)}
                            </div>
                            <div className="col-md-3">
                                <strong>Ödenen:</strong> {getPaidCount()}/{report.financialData?.term}
                            </div>
                            <div className="col-md-3">
                                <strong>Kalan:</strong> {report.financialData?.term - getPaidCount()}
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Table striped bordered hover size="sm" className={isSettled ? 'text-muted' : ''}>
                            <thead>
                                <tr>
                                    <th className="text-center">Taksit No</th>
                                    <th>Ödeme Tarihi</th>
                                    <th>Tutar</th>
                                    <th>Durum</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(() => {
                                    // Yapılandırmaları grupla
                                    const groups = [];
                                    let currentGroup = null;

                                    paymentPlan.forEach((payment, index) => {
                                        if (payment.isRestructured) {
                                            const restructuringId = payment.restructuringId?.toString() || 'unknown';

                                            // Yeni grup mu?
                                            if (!currentGroup || currentGroup.restructuringId !== restructuringId) {
                                                currentGroup = {
                                                    restructuringId,
                                                    restructuringDate: payment.restructuringDate,
                                                    payments: [],
                                                    isRestructuring: true
                                                };
                                                groups.push(currentGroup);
                                            }
                                            currentGroup.payments.push({ ...payment, originalIndex: index });
                                        } else {
                                            // Orijinal taksitler - ilk gruba ekle
                                            if (groups.length === 0 || groups[0].isRestructuring) {
                                                groups.unshift({
                                                    restructuringId: 'original',
                                                    payments: [],
                                                    isRestructuring: false
                                                });
                                            }
                                            groups[0].payments.push({ ...payment, originalIndex: index });
                                        }
                                    });

                                    // Her grubu render et
                                    return groups.map((group, groupIndex) => (
                                        <React.Fragment key={group.restructuringId}>
                                            {/* Yapılandırma başlığı */}
                                            {group.isRestructuring && (
                                                <>
                                                    <tr className="table-active">
                                                        <td colSpan="4" className="text-center py-2 bg-info">
                                                            <strong>
                                                                ━━━ YAPILANDIRMA-{groupIndex}
                                                                {group.restructuringDate &&
                                                                    ` (${new Date(group.restructuringDate).toLocaleDateString('tr-TR')})`
                                                                } ━━━
                                                            </strong>
                                                        </td>
                                                    </tr>
                                                    <tr className="table-info">
                                                        <td colSpan="4" className="py-3">
                                                            <div className="row px-3">
                                                                <div className="col-12 mb-2">
                                                                    <strong>📋 YAPILANDIRMA BİLGİLERİ:</strong>
                                                                </div>
                                                                {(() => {
                                                                    const restructuredPaidCount = group.payments.filter(p => p.paymentStatus === 'paid').length;
                                                                    const totalRestructured = group.payments[0]?.totalRestructuredTaksit || group.payments.length;
                                                                    const avgPayment = group.payments.reduce((sum, p) => sum + p.taksitTutari, 0) / group.payments.length;

                                                                    return (
                                                                        <>
                                                                            <div className="col-md-3">
                                                                                <strong>Toplam Taksit:</strong> {totalRestructured} ay
                                                                            </div>
                                                                            <div className="col-md-3">
                                                                                <strong>Aylık Tutar:</strong> {formatCurrency(Math.round(avgPayment))}
                                                                            </div>
                                                                            <div className="col-md-3">
                                                                                <strong>Ödenen:</strong> {restructuredPaidCount}/{totalRestructured}
                                                                            </div>
                                                                            <div className="col-md-3">
                                                                                <strong>Kalan:</strong> {totalRestructured - restructuredPaidCount}
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })()}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </>
                                            )}

                                            {/* Taksit satırları */}
                                            {group.payments.map((payment) => (
                                                <tr key={payment.originalIndex} className={isSettled ? 'table-secondary' : ''}>
                                                    <td className="text-center">
                                                        <strong>
                                                            {payment.isRestructured
                                                                ? `${payment.restructuredTaksitNo}/${payment.totalRestructuredTaksit}`
                                                                : `${payment.taksit}/${report.financialData?.term}`
                                                            }
                                                        </strong>
                                                    </td>
                                                    <td>{formatDate(payment.taksitTarihi)}</td>
                                                    <td>{formatCurrency(payment.taksitTutari)}</td>
                                                    <td>
                                                        {isSettled || payment.paymentStatus === 'restructured' ? (
                                                            <Badge bg={getStatusBadge(payment.paymentStatus)}>
                                                                {payment.paymentStatus === 'paid' ? 'Tahsil' :
                                                                    payment.paymentStatus === 'erken_kapama' ? 'Erken Kapama' :
                                                                        payment.paymentStatus === 'restructured' ? 'Yapılandırıldı' : 'Portföy'}
                                                            </Badge>
                                                        ) : (
                                                            <Form.Select
                                                                size="sm"
                                                                value={payment.paymentStatus || 'pending'}
                                                                onChange={(e) => handleStatusChange(payment.originalIndex, e.target.value)}
                                                                className={`bg-${getStatusBadge(payment.paymentStatus)}`}
                                                                style={{ maxWidth: '120px' }}
                                                            >
                                                                <option value="pending">Portföy</option>
                                                                <option value="paid">Tahsil</option>
                                                                <option value="erken_kapama">Erken Kapama</option>
                                                            </Form.Select>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    ));
                                })()}
                            </tbody>
                        </Table>
                    </div>

                    {paymentPlan.length === 0 && (
                        <div className="text-center py-3">
                            <p className="text-muted">Ödeme planı bulunamadı</p>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        setShowPaymentList(false);
                        onHide();
                    }} disabled={saving}>
                        <FaTimes className="me-2" />
                        Kapat
                    </Button>
                    {!isSettled && (
                        <Button variant="primary" onClick={handleSave} disabled={saving}>
                            {saving ? (
                                <Spinner size="sm" animation="border" className="me-2" />
                            ) : (
                                <FaSave className="me-2" />
                            )}
                            {saving ? 'Kaydediliyor...' : 'Kaydet'}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        );
    }

    if (showEarlyCalculator && settlementData) {
        return (
            <Modal show={true} onHide={() => setShowEarlyCalculator(false)} centered style={{ zIndex: 10000 }} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FaCalculator className="text-success me-2" />
                        🧮 ERKEN SETTLEMENT HESAPLAYICI
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && (
                        <Alert variant="danger" className="mb-3">
                            {error}
                        </Alert>
                    )}

                    {/* HİBRİT DURUM UYARISI */}
                    {settlementData.isHybridCase && (
                        <Alert variant="warning" className="mb-3">
                            <FaExclamationTriangle className="me-2" />
                            ⚠️ UYARI: Bu hesapta hem gecikme cezası hem erken kapama bedeli bulunmaktadır!
                        </Alert>
                    )}

                    <div className="mb-3">
                        <p><strong>Ödenen Taksit:</strong> {settlementData.paidInstallmentCount}/{settlementData.paidInstallmentCount + settlementData.remainingInstallments}</p>
                    </div>

                    {/* HESAPLAMA DETAYLARI */}
                    <div className="settlement-calculation">
                        <div className="d-flex justify-content-between py-2 border-bottom">
                            <span>Kalan Ana Para:</span>
                            <strong>{formatCurrency(settlementData.remainingPrincipal)}</strong>
                        </div>
                        <div className="d-flex justify-content-between py-2 border-bottom">
                            <span>Kalan Faiz:</span>
                            <strong>{formatCurrency(settlementData.remainingInterest)}</strong>
                        </div>
                        <div className="d-flex justify-content-between py-2 border-bottom">
                            <span>Faiz Cezası (%10):</span>
                            <strong>{formatCurrency(settlementData.interestPenalty)}</strong>
                        </div>

                        {/* GECIKME CEZASI (VARSA) */}
                        {settlementData.hasLatePenalty && (
                            <div className="d-flex justify-content-between py-2 border-bottom text-danger">
                                <span>Gecikme Cezası ({settlementData.lateDetails?.overdueDays} gün):</span>
                                <strong>{formatCurrency(settlementData.latePenalty)}</strong>
                            </div>
                        )}

                        {/* ERKEN KAPAMA BEDELİ (VARSA) */}
                        {settlementData.hasEarlySettlementFee && (
                            <div className="d-flex justify-content-between py-2 border-bottom text-info">
                                <span>Erken Kapama Bedeli ({settlementData.earlyDetails?.earlyDays} gün):</span>
                                <strong>{formatCurrency(settlementData.earlySettlementFee)}</strong>
                            </div>
                        )}

                        <div className="d-flex justify-content-between py-3 border-top">
                            <span><strong>TOPLAM ÖDENECEK MEBLA:</strong></span>
                            <strong className="text-success fs-5">{formatCurrency(settlementData.totalPayableAmount)}</strong>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEarlyCalculator(false)}>
                        İptal
                    </Button>
                    <Button
                        variant="success"
                        onClick={handleConfirmEarlySettlement}
                        disabled={loadingConfirm}
                    >
                        {loadingConfirm ? (
                            <>
                                <Spinner size="sm" animation="border" className="me-2" />
                                Onaylanıyor...
                            </>
                        ) : (
                            <>
                                <FaLock className="me-2" />
                                🔐 Onayla ve Kaydet
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    // Fallback: Modal kapalı
    return null;
};

export default PaymentPlanModal;

